import type { ExternalIntegrationsParams } from 'queries/external-integrations/types'

export const externalIntegrationsQueryKeys = {
  get: (params: ExternalIntegrationsParams) =>
    ['external-integrations', params] as const,
  getLoadGeneratorIntegrations: (params: { teamId: string }) =>
    ['external-integrations/load-generator', params] as const,
  getStatusCheckIntegrations: (params: { teamId: string }) =>
    ['external-integrations/status-check', params] as const
}

export const externalIntegrationsMutationKeys = {
  delete: (params?: ExternalIntegrationsParams) =>
    ['external-integrations', params, { method: 'delete' }] as const
}
